import { resolveComponent as _resolveComponent, withModifiers as _withModifiers, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mb-8 shadow-md px-8 py-4" }
const _hoisted_2 = { class: "grid grid-cols-12" }
const _hoisted_3 = { class: "col-span-12 md:col-span-6" }
const _hoisted_4 = { class: "p-input-icon-right w-full" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_6 = {
  key: 0,
  id: "content"
}
const _hoisted_7 = { class: "grid grid-cols-12 gap-3 p-8" }
const _hoisted_8 = {
  key: 0,
  class: "border-t-2 border-gray-100 mt-8 flex justify-end px-8 py-2"
}
const _hoisted_9 = {
  key: 1,
  class: "py-20"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InputText = _resolveComponent("InputText")!
  const _component_Loader = _resolveComponent("Loader")!
  const _component_CardCourseComponent = _resolveComponent("CardCourseComponent")!
  const _component_Paginator = _resolveComponent("Paginator")!
  const _component_EmptyData = _resolveComponent("EmptyData")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("span", _hoisted_4, [
            _createVNode(_component_InputText, {
              type: "text",
              modelValue: _ctx.filterByName,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.filterByName) = $event)),
              placeholder: _ctx.$t('course.search'),
              class: "p-inputtext-sm",
              onKeyup: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (_ctx.filterCourseByName()), ["stop"]))
            }, null, 8, ["modelValue", "placeholder"]),
            _hoisted_5
          ])
        ])
      ])
    ]),
    _createVNode(_component_Loader, {
      loader: _ctx.loading,
      loaderSize: "h-96"
    }, null, 8, ["loader"]),
    ((_ctx.courses || _ctx.courses.length !== 0) && !_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.courses, (course, i) => {
              return (_openBlock(), _createElementBlock("div", {
                key: i,
                class: "col-span-12 sm:col-span-4 lg:col-span-3 xl:col-span-3 hover:cursor-pointer hover:shadow-lg"
              }, [
                _createVNode(_component_CardCourseComponent, {
                  course: course,
                  stats: true,
                  onClick: _withModifiers(($event: any) => (_ctx.goToCourse(course)), ["prevent"])
                }, null, 8, ["course", "onClick"])
              ]))
            }), 128))
          ]),
          (_ctx.params?.total > _ctx.params?.size)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_Paginator, {
                  rows: _ctx.params?.size,
                  totalRecords: _ctx.params?.total,
                  onPage: _cache[2] || (_cache[2] = ($event: any) => (_ctx.paginate($event))),
                  rowsPerPageOptions: [_ctx.params?.size, 20, 30]
                }, null, 8, ["rows", "totalRecords", "rowsPerPageOptions"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    ((!_ctx.courses || _ctx.courses.length === 0) && !_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
          _createVNode(_component_EmptyData, {
            data: !_ctx.courses || _ctx.courses.length == 0,
            label: _ctx.emptyState.description,
            image: _ctx.emptyState.image,
            imgSize: "h-40 md:h-64"
          }, null, 8, ["data", "label", "image"])
        ]))
      : _createCommentVNode("", true)
  ]))
}